"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductImplementationCommonDocumentSearchResponse = void 0;
const common_1 = require("../../common");
const models_1 = require("../models");
class ProductImplementationCommonDocumentSearchResponse extends common_1.PaginatedResponse {
}
exports.ProductImplementationCommonDocumentSearchResponse = ProductImplementationCommonDocumentSearchResponse;
//# sourceMappingURL=product-implementation-common-document-search.response.js.map